module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/bg3-c69dc12c1c6c6236525be860946cc9df.jpg";